import { isOfType } from '../../../../ts-utils';
import { SHOW_TOAST } from './show-toast-action';
import { TRY_OPEN_COMMENT_BOX, TRY_CLOSE_ALL_COMMENT_BOXES, } from './comment-box-actions';
export const isEffectsAction = isOfType([
    TRY_OPEN_COMMENT_BOX,
    TRY_CLOSE_ALL_COMMENT_BOXES,
    SHOW_TOAST,
]);
//# sourceMappingURL=effects-actions.js.map